// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation_iO1OW{margin:4rem 0;overflow:hidden}@media only screen and (min-width:1264px){.navigation_iO1OW{margin:8rem 0}}.pagination_03jt6{margin:0 -40px;text-align:center}@media only screen and (min-width:1264px){.pagination_03jt6{margin:0}}.selectWrapper_xOPDS{display:flex;justify-content:flex-end;margin-top:40px}@media only screen and (min-width:1264px){.selectWrapper_xOPDS{margin-top:48px}}.navigation_iO1OW .selectPerPage_hQyOA{width:137px}.navigation_iO1OW .selectPerPage_hQyOA:before{content:\"Items Per Page\"}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation": "navigation_iO1OW",
	"pagination": "pagination_03jt6",
	"selectWrapper": "selectWrapper_xOPDS",
	"selectPerPage": "selectPerPage_hQyOA"
};
module.exports = ___CSS_LOADER_EXPORT___;
